import {useEffect, useState} from 'react'
import {formatDate} from 'utils/intlDate'
import SearchContainer from 'layouts/components/Search/SearchContainer'
import RangePicker from 'components/ui/RangePicker'
import Table from 'components/ui/Table'
import {useNavigate} from 'react-router-dom'
import * as Styles from 'layouts/PrivateLayout.styles'
import Button from 'components/ui/Button'
import {IOrder, useGetTopOrdersQuery} from 'services/orders'
import {formatCurrency} from 'utils/intlNumber'
import Spinner from 'components/ui/Spinner'

const Orders = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [limit] = useState(20);

    // Set initial dates to today
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD

    const [startDate, setStartDate] = useState(formattedToday);
    const [endDate, setEndDate] = useState(formattedToday);

    const {
        data: topOrders,
        isLoading,
        isFetching,
        refetch
    } = useGetTopOrdersQuery({page, limit, startDate, endDate});

    const sortedOrders = topOrders?.orders?.slice().sort((a, b) => {
        const dateA = new Date(a.deliveryDate).getTime();
        const dateB = new Date(b.deliveryDate).getTime();
        return dateA - dateB;
    });

    const filteredOrders = sortedOrders?.filter((order => !order.confirmed_delivery_date))

    useEffect(() => {
        refetch();
    }, [startDate, endDate, refetch]);

    const columns = [
        {
            field: 'delivery_date',
            headerName: 'Delivery Date',
            render: (data: IOrder) => formatDate(data?.deliveryDate)
        },
        {
            field: 'order_number',
            headerName: 'Order Number',
            render: (data: IOrder) => `#${data?.order_number}`
        },
        {
            field: 'name',
            headerName: 'Name',
            render: (data: IOrder) => data?.customer?.name
        },
        {
            field: 'location',
            headerName: 'Location',
            render: (data: IOrder) => data?.locations?.name 
        },
        {
            field: 'email',
            headerName: 'Email address',
            render: (data: IOrder) => data?.customer?.email
        },
        {
            field: 'total',
            headerName: 'Total',
            sortable: false,
            render: (data: IOrder) => formatCurrency(Number(data?.total_price ?? 0))
        }
    ]

    const handleRowClick = (id: number) => {
        navigate(`/admin/orders/${id}`)
    }

    return (
        <div>
            <SearchContainer/>
            <div className="mt-5">
                <Styles.PageTitleContainer>
                    Orders
                    <Styles.PageTitleContainerButtons>
                        <RangePicker
                            startDate={startDate}
                            endDate={endDate}
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                        />
                        {/*<Button onClick={() => navigate('/admin/export')}>Export CSV</Button>*/}
                        {/*<Button cc-color='purple' onClick={() => navigate('/admin/order/create')}>Create Order</Button>*/}
                    </Styles.PageTitleContainerButtons>
                </Styles.PageTitleContainer>
            </div>
            {!isLoading && !isFetching ? (
                <Table
                    columns={columns}
                    rows={filteredOrders || []}
                    onRowClick={handleRowClick}
                    isFetching={isFetching || isLoading}
                    showPagination
                    page={page}
                    setPage={setPage}
                    onPrevPage={() => setPage(page - 1)}
                    onNextPage={() => setPage(page + 1)}
                    totalPages={Math.ceil(Number(topOrders?.records_count) / limit)}
                    usePointer
                    emptyTitleText="No orders yet"
                    emptyText="There are no orders available, try selecting a different date range!"
                />
            ) : (
                <Spinner/>
            )}
        </div>
    )
}

export default Orders
